// @flow
import config from '../../config';
import { createApiCall } from './api-factory';
import { buildScenarioQueryParams } from './search-scenario-optimizations-request';

const BASE_URL = config.SHIPMENT_COMPARISON_ANALYTICS_URL;

const makeApiCall = createApiCall(BASE_URL, buildScenarioQueryParams);

function getShipmentComparisonAnalyticsNoShipments(query): any {
    const endpoint = '/shipments_count';
    return makeApiCall(endpoint, query);
}

function getShipmentComparisonAnalyticsTopZone(query): any {
    const endpoint = '/top_zone';
    return makeApiCall(endpoint, query);
}

function getShipmentComparisonAnalyticsTopWeight(query): any {
    const endpoint = '/top_weight';
    return makeApiCall(endpoint, query);
}

function getShipmentComparisonAnalyticsBaseChargeAmount(query): any {
    const endpoint = '/base_charge_amount';
    return makeApiCall(endpoint, query);
}

function getShipmentComparisonAnalyticsAvgBaseChargeAmount(query): any {
    const endpoint = '/average_base_charge_amount';
    return makeApiCall(endpoint, query);
}

const getShipmentComparisonBaseChargeAmount = (query: Query | string): Promise<any> => {
    const endpoint = '/comparison_base_charge_amount';
    return makeApiCall(endpoint, query);
};

const getShipmentComparisonAvgBaseChargeAmount = (query: Query | string): Promise<any> => {
    const endpoint = '/comparison_average_base_charge_amount';
    return makeApiCall(endpoint, query);
};

const getShipmentComparisonAnalyticsRecords = (query: Query | string): Promise<any> => {
    const endpoint = '/comparison_records';
    return makeApiCall(endpoint, query);
};

const getShipmentComparisonAnalyticsReport = (query: Query | string): Promise<any> => {
    const endpoint = '/comparison_analytics_report';
    return makeApiCall(endpoint, query);
};

// const getTotalNoSurcharges = (query: Query | string): Promise<any> => {
//     const endpoint = '/total_no_surcharges';
//     return makeApiCall(endpoint, query);
// };

// const getTotalNoIntegrationSurcharges = (query: Query | string): Promise<any> => {
//     const endpoint = '/total_no_integration_surcharges';
//     return makeApiCall(endpoint, query);
// };

// const getTotalSurchargesCost = (query: Query | string): Promise<any> => {
//     const endpoint = '/total_surcharges_cost';
//     return makeApiCall(endpoint, query);
// };

// const getTotalIntegrationSurchargesCost = (query: Query | string): Promise<any> => {
//     const endpoint = '/total_integration_surcharges_cost';
//     return makeApiCall(endpoint, query);
// };

// const getSurchargeSummary = (query: Query | string): Promise<any> => {
//     const endpoint = '/surcharges_summary';
//     return makeApiCall(endpoint, query);
// };

// const getIntegrationSurchargeSummary = (query: Query | string): Promise<any> => {
//     const endpoint = '/integration_surcharges_summary';
//     return makeApiCall(endpoint, query);
// };

const getCountByWeightAndZone = (query: Query | string): Promise<any> => {
    const endpoint = '/count_by_weight_and_zone';
    return makeApiCall(endpoint, query);
};

export {
    getShipmentComparisonAnalyticsNoShipments,
    getShipmentComparisonAnalyticsTopZone,
    getShipmentComparisonAnalyticsTopWeight,
    getShipmentComparisonAnalyticsBaseChargeAmount,
    getShipmentComparisonAnalyticsAvgBaseChargeAmount,
    getShipmentComparisonBaseChargeAmount,
    getShipmentComparisonAvgBaseChargeAmount,
    getShipmentComparisonAnalyticsRecords,
    // getTotalNoSurcharges,
    // getTotalNoIntegrationSurcharges,
    // getTotalSurchargesCost,
    // getTotalIntegrationSurchargesCost,
    // getSurchargeSummary,
    // getIntegrationSurchargeSummary,
    getCountByWeightAndZone,
    getShipmentComparisonAnalyticsReport,
};
